module.exports = __webpack_public_path__ + "img/facilities-icon-4.9b555c22.svg";